export const classes = {
  trigger: 'place-center flex-col gap-2 w-full min-h-[5rem]',
  triggerImage: 'object-contain h-16 w-auto',
  triggerLabel: 'text-sm font-medium text-grey-8 dark:text-mauve-1 text-center',
  caret: 'w-5 h-5 shrink-0 text-grey-6 dark:text-mauve-3',
  popoverPaper: 'rounded-2xl shadow-pop-up p-2 dark:bg-[#332e43]',
  optionsGrid: 'grid gap-2 max-w-[90vw]',
  optionsGridCols1: 'grid-cols-1',
  optionsGridCols2: 'grid-cols-2',
  optionsGridCols3: 'grid-cols-3',
  option:
    'place-center flex-col gap-1.5 p-3 w-[8rem] min-h-[8.5rem] rounded-xl border cursor-pointer transition-colors text-center',
  optionDefault:
    'border-transparent hover:bg-grey-2 dark:hover:bg-white/[0.06]',
  optionSelected: 'border-brand-orange bg-orange-1/30 dark:bg-orange-3/[0.16]',
  optionImage: 'object-contain h-14 w-auto',
  optionLabel: 'text-sm text-grey-8 dark:text-mauve-1',
  optionLabelSelected: 'font-medium text-grey-9 dark:text-mauve-1',
};

export function getOptionsGridClass(optionCount: number) {
  if (optionCount === 1) return classes.optionsGridCols1;
  if (optionCount === 2) return classes.optionsGridCols2;
  return classes.optionsGridCols3;
}
